import React from "react";
import { SnackbarProvider } from "notistack";
import { Toast } from "components/Toast";
import { FormLinkRouting } from "./FormLinkRouting";
import { Fonts, FontFamilies } from "theme/fontConfig";
export const FormLink = () => {
  return (
    <>
      <SnackbarProvider
        maxSnack={1}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={4000}
        style={{ fontFamily: FontFamilies.General, fontSize: Fonts.GeneralLargeBodyFont.fontSize }}
      >
        <FormLinkRouting />
      </SnackbarProvider>
      <Toast />
    </>
  );
};
